import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { AuthServiceProvider } from 'src/app/services/col2/auth.service';
import { ErrorModalDetails, ErrorModalService } from 'src/app/services/col2/error-modal.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent implements OnInit, OnDestroy {

  @ViewChild("errorModal", { static: true })
  errorModal: ModalComponent

  private errorSubscription: Subscription
  error: ErrorModalDetails
  countdown: any
  redirectCountdown = 5

  title: string
  message: string

  constructor(
    private errorModalService: ErrorModalService,
    private authService: AuthServiceProvider
  ) { }

  ngOnInit(): void {
    this.errorSubscription = this.errorModalService.error.subscribe(
      error => this.displayErrorModal(error)
    )
  }

  ngOnDestroy(): void {
    this.errorSubscription.unsubscribe()
  }

  displayErrorModal(error: ErrorModalDetails) {
    this.error = error

    if (this.error.timeout && this.error.hasToLogout) {
      this.redirectCountdown = this.error.timeout
      this.countdown = setInterval(() => {
        if (this.redirectCountdown === 0) {
          clearInterval(this.countdown)
          this.errorModal.hide()
          this.logOut()
        }
        else {
          this.redirectCountdown -= 1
        }
      }, 1000)
    } 
    this.errorModal.show(this.error?.cancellable)
  }

  getTitle() {
    return this.error?.title || ""
  }

  getMessage() {
    return this.error?.message || ""
  }

  logOut(): void {
    this.authService.get().subscribe(api => api.logout());
  }
}
